// Note: shared by the connector lines and the selected row's border so they match
export const LINK_STROKE_WIDTH = 1.5

// Note: the column header row (the add button height); the lists start under it
export const COLUMN_HEADER_MIN_HEIGHT = '3.2rem'
